import { IApplicationScopeRef, IApplicationsLanguages, ITotal } from '../types';

export const getEmptyArray = (length: number): undefined[] => {
  return new Array(length).fill(undefined);
};

export const sortScopeRef = (a: IApplicationScopeRef, b: IApplicationScopeRef, sortingScheme: string[]): number => {
  return sortingScheme.indexOf(a.key) < sortingScheme.indexOf(b.key) ? -1 : 1;
};

export const uniq = <T>(arr: T[]): T[] => {
  return arr.filter((value, index, self) => self.indexOf(value) === index);
};

export function uniqArrayObjectByKey<Type>(objArray: Type[], key: keyof Type): Type[] {
  return [...new Map(objArray.map((item) => [item[key], item])).values()];
}

export function uniqArrayObjectByKeys<T>(objArray: T[], keys: (keyof T)[]): T[] {
  return objArray.filter((v, i, a) => keys.some((key) => a.map((a) => a[key]).indexOf(v[key]) === i));
}

export const getTotalCostDiffPercentage = (actualCost: ITotal[], previousCost: ITotal[]): string => {
  const actualValues = actualCost.reduce((acc, curr) => acc + (curr.value ? (curr.value as number) : 0), 0);
  const prevValues = previousCost.reduce((acc, curr) => acc + (curr.value ? (curr.value as number) : 0), 0);

  const diff = prevValues === 0 ? 100 : ((actualValues - prevValues) / prevValues) * 100;

  return diff.toFixed(1);
};

export const filterProgressBarElement = (elements: IApplicationsLanguages[]) => {
  return elements.filter(
    (element) => !element.percentage?.toString().startsWith('0.0') && !element.percentage?.toString().includes('e')
  );
};

export function* chunks<T>(arr: T[], n: number): Generator<T[]> {
  for (let i = 0; i < arr.length; i += n) {
    yield arr.slice(i, i + n);
  }
}

export const getMaxOccurrences = (itemsArray: string[]) => {
  return itemsArray.length > 0
    ? itemsArray.reduce(
        (acc, item) =>
          itemsArray.filter((v) => v === acc).length >= itemsArray.filter((v) => v === item).length ? acc : item,
        ''
      )
    : '';
};

export const smoothScrollTo = (id: string) => {
  const element = document.getElementById(id);
  if (!element) return;

  element.scrollIntoView({
    block: 'start',
    behavior: 'smooth', // smooth scroll
  });
};
